import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { TABS } from 'v-c/Search/SearchTool';
import { useMessages } from 'component-utilities/intl';
import { useRouteLeaveHook } from '../../global/lib/routeLeaveHook';
import locationQuery from '../../global/lib/locationQuery';

import Layout from '../../global/components/Layout';
import HeadlineLabel from '../../global/components/HeadlineLabel';
import FormView from './NewSearchResults/FormView';

import { resetAll as resetSearchFormState } from '../../global/state_managers/SearchFormStateManager';
import { resetCurrentSavedSearch } from '../../global/state_managers/CurrentSavedSearchStateManager';
import { resetUnsavedSearch } from '../../global/state_managers/UnsavedSearchStateManager';
import { breadcrumbsActions } from '../../global/state_managers/BreadcrumbsStateManager';
import { setInitialTableConfig } from '../../global/state_managers/SearchResults/tableConfig';

function NewSearchResults() {
  const dispatch = useDispatch();
  const location = useLocation();
  const getMessage = useMessages();
  
  const searchForm = useSelector((state: any) => state.searchForm);
  
  useRouteLeaveHook();

  // Initialize on mount - dispatch actions after render
  useEffect(() => {
    // react-router v8 `location` has no `.query`; parse it from `search`.
    if (!locationQuery(location).skipReset) {
      dispatch(resetCurrentSavedSearch());
      dispatch(resetSearchFormState());
      dispatch(resetUnsavedSearch());
      dispatch(setInitialTableConfig('unsavedSearch'));
    }

    dispatch(breadcrumbsActions.newSearchPage());
  }, [dispatch, location.search]);

  const isSimpleView = searchForm.currentView === TABS.SIMPLE;

  const layoutAttributes = {
    staticView: isSimpleView ? true : null,
  };

  return (
    <Layout section="new-search" {...layoutAttributes}>
      <header>
        <HeadlineLabel
          text={getMessage('app.breadcrumb.new_search')}
        />
      </header>
      <FormView
        isSimpleView={isSimpleView}
        isInitialForm
      />
    </Layout>
  );
}

export default NewSearchResults;
